<template>
  <div class="page-container">
    <h1 style="text-align: center">Reaper2MA</h1>
    <h3 style="text-align:center">Converter</h3>

    <md-field :class="resultfileNameClass">
      <label>What should the result file be named?</label>
      <md-input name="name" v-model="name" required></md-input>
      <span class="md-error">You need to provide a name for the result file.</span>
    </md-field>

    <md-field :class="sequenceNumberClass">
      <label>What sequenceNumber should the timcode map to?</label>
      <md-input name="sequenceNumber" v-model="sequenceNumber" required></md-input>
      <span class="md-error">The input is invalid. It should only contain numbers</span>
    </md-field>

    <vue-csv-import
      ref="csvimporter"
      v-model="csv"
      checkboxClass="test"
      tableClass="csv-import-table"
      :map-fields="['cue_number', 'cue_name', 'time']"
    >
      <template slot="error">File type is invalid</template>

      <template slot="thead">
        <tr>
          <th>Fileds</th>
          <th>Column</th>
        </tr>
      </template>

      <template slot="next" slot-scope="{load}">
        <md-button class="md-raised" @click.prevent="load">Load</md-button>
      </template>
    </vue-csv-import>

    <div class="convertclearbuttons" v-if="csv !== null">
      <md-button
        class="md-raised"
        :disabled="csv==null || name == '' || sequenceNumber == '' || validateSequenceNumber()"
        @click="cues"
      >Cues</md-button>

      <md-button
        class="md-raised"
        :disabled="csv==null || name == '' || sequenceNumber == '' || validateSequenceNumber()"
        @click="timecode"
      >Timecode</md-button>

      <md-button v-if="false" class="md-raised" :disabled="csv==null" @click="clear">Clear</md-button>
    </div>
    <md-divider></md-divider>
    <h2 style="text-align: center">How to</h2>
    <p style="text-align: center">
      The converter takes a csv file with the following columns
      <br />
      <br />
      <md-table class="u-full-width">
        <md-table-row>
          <md-table-head>cue number</md-table-head>
          <md-table-head>cue name</md-table-head>
          <md-table-head>time (in seconds)</md-table-head>
        </md-table-row>
        <md-table-row>
          <md-table-cell>1</md-table-cell>
          <md-table-cell>intro</md-table-cell>
          <md-table-cell>11.943</md-table-cell>
        </md-table-row>
        <md-table-row>
          <md-table-cell>2</md-table-cell>
          <md-table-cell>verse</md-table-cell>
          <md-table-cell>30.345</md-table-cell>
        </md-table-row>
      </md-table>
    </p>
    <md-dialog-alert
      :md-active.sync="errordialog"
      md-title="Error"
      md-content="An error occured, please try again."
      md-confirm-text="Ok"
    ></md-dialog-alert>
  </div>
</template>

<script>
import Vue from "vue";
import VueMaterial from "vue-material";
//import VueCsvImport from "vue-csv-import";
import VueCsvImport from "./components/CSVupload";
//import { MdButton, MdContent, MdTabs } from 'vue-material/dist/components'
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";
import ma2 from "./scripts/ma_timecode.js";

Vue.use(VueMaterial);

export default {
  components: {
    VueCsvImport
  },
  methods: {
    clear: function() {
      this.csv = null;
      this.name = null;
      this.sequenceNumber = null;
      this.$refs.csvimporter.clear();
    },
    cues: function() {
      var _this = this;
      ma2(this.csv, this.sequenceNumber, this.name, false).then(
        () => {
          //window.location.reload();
        },
        function(err) {
          // eslint-disable-next-line
          console.log(err);
          _this.errordialog = true;
        }
      );
    },
    timecode: function() {
      var _this = this;
      ma2(this.csv, this.sequenceNumber, this.name, true).then(
        () => {
          //window.location.reload();
        },
        function(err) {
          // eslint-disable-next-line
          console.log(err);
          _this.errordialog = true;
        }
      );
    },
    validateSequenceNumber() {
      return isNaN(this.sequenceNumber);
    },
    validateFileName() {
      if (this.name == null || this.name == "") {
        this.name = "";
        return false;
      }
      return true;
    }
  },
  computed: {
    sequenceNumberClass() {
      return {
        "md-invalid": this.validateSequenceNumber()
      };
    },
    resultfileNameClass() {
      return {
        "md-invalid": this.name != "" ? false : true
      };
    }
  },
  data() {
    return {
      csv: null,
      message: "Reaper2MA",
      name: null,
      sequenceNumber: "",
      makeTimecode: false,
      error: null,
      errordialog: false
    };
  }
};
</script>

<style>
.page-container {
  width: 90vw;
  max-width: 700px;
  min-width: 320px;
  margin: auto;
}
.csv-import-table {
  width: 50%;
  padding: 1em 0em;
  margin: auto;
  background-color: white;
}

.csv-import-table td {
  text-align: right;
  padding: 0.2em 1em;
  width: 50%;
}
.csv-import-table td select {
  width: 100%;
}
</style>